import Web3 from 'web3';
import {useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const MetaMask = props => {
  const handleAccountsChanged = (data) => {
    props.blockchain.metamask.setAccounts(data);
    if (data.length === 0) {
      props.blockchain.metamask.setIsConnected(false);
    } else {
      props.blockchain.metamask.setIsConnected(true);
    }
  }

  useEffect(()=> {
    if (typeof window.ethereum !== 'undefined' || (typeof window.web3 !== 'undefined')) {
      props.blockchain.metamask.setWeb3(new Web3(window.ethereum));
      window.ethereum.on("accountsChanged", handleAccountsChanged);
      window.ethereum.autoRefreshOnNetworkChange = false;
      props.blockchain.metamask.setIsInstalled(true);
    } else {
      props.blockchain.metamask.setIsInstalled(false);
    }
  },[])

  useEffect(() => {
    const load = async() => {
      const localAccounts = await props.blockchain.metamask.web3.eth.getAccounts();
      props.blockchain.metamask.setAccounts(localAccounts);
    }
    if (typeof props.blockchain.metamask.web3 !== "undefined") {
      load();
    }
  },[props.blockchain.metamask.web3]);

  const handleMetamaskClick = async() => {
    props.setModal({enabled:true, message:"Purchases from this website are paused. The launch will take place on Artblocks.io!"});

    /*
    try {
      await window.ethereum.enable();
      props.blockchain.metamask.setIsConnected(true);
    } catch(e) {
      if (e.code === 4001) {
        props.setModal({enabled:true, message:"A connection to Metamask is necessary to mint a Spectron token."});
      } else {
        props.setModal({enabled:true, message:e.message});
      }
      return;
    } */
  }

  const shortenAddress = address => {
    return (address.substr(0,6) + "..." + address.substr(address.length-6, 6))
  }

  if (props.blockchain.metamask.accounts.length !== 0 && props.blockchain.metamask.isConnected) {
    return (
      <div className="has-text-right">
        <p className="sp-label">Logged in as</p>
        <p className="is-size-7">{shortenAddress(props.blockchain.metamask.accounts[0])}</p> 
      </div>
    )
  } else {
    return (
      <div className="buttons is-right ">
        { props.blockchain.metamask.isInstalled ? (
        <button onClick={handleMetamaskClick} className={"metamask button is-size-7 is-primary is-rounded is-outlined" + (props.isNegative ? " is-inverted" : "")}>Connect to Metamask</button> 
        ) : (
        <a href="https://metamask.io/" target="_blank" rel="noreferrer" className={"metamask button is-size-7 is-primary is-rounded is-outlined" + (props.isNegative ? " is-inverted" : "")}>Install Metamask</a> 
        ) }
      </div>
    )
  }
}

const Header = props => {
  const location = useLocation();
  let isNegative = false;
  if (location.pathname === "/") { isNegative = true; }

  const handleBuyClick = e => {
    if (!props.blockchain.metamask.isConnected) {
      e.preventDefault();
      props.setModal({enabled:true, message:"You are not connected to the Ethereum blockchain, please connect to Metamask."});
    } 

   
  } 

    return (
      <motion.section 
        className="section"
        initial={{y:-100, opacity:0}}
        animate={{y:0, opacity:1}}
        transition={{delay:0.2, duration:0.5}}
      >
          <div className={"columns" + (isNegative ? "" : " has-text-black")}>
  
            <div className="column is-3">
              <NavLink 
                to="/" 
                activeClassName={"is-active"}
                className={"is-size-4 sp-logo" + (isNegative ? "" : " has-text-black")}>
                Spectron
              </NavLink>
            </div>

            <div className="column is-6">
              <div className="buttons is-centered nav is-size-7">
                <NavLink 
                  to="/about" 
                  className={"button is-size-7 is-primary is-rounded is-outlined" + (isNegative ? " is-inverted" : "")}>
                  About
                </NavLink>
                <NavLink 
                  to="/gallery" 
                  className={"button is-size-7 is-primary is-rounded is-outlined" + (isNegative ? " is-inverted" : "")}>
                  Gallery
                </NavLink>
                <NavLink
                  to="/buy" 
                  className={"button is-size-7 is-primary is-rounded is-outlined" + (isNegative ? " is-inverted" : "")} 
                  disabled={!props.blockchain.metamask.isConnected}
                  onClick={handleBuyClick}
                  >
                Buy
                </NavLink>
              </div>
            </div>

            <div className="column is-3 is-hidden-mobile">
              <MetaMask 
                isNegative={isNegative} 
                blockchain={props.blockchain}
                setModal={props.setModal}
              />
            </div>

          </div>
      </motion.section>
    )
  };

  export default Header;